var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4zm2 1v9a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11a4 4 0 0 1-8 0v-1a1 1 0 1 1 2 0v1a2 2 0 1 0 4 0v-1a1 1 0 1 1 2 0zM6.168 3.445A1 1 0 0 1 7 3h10a1 1 0 0 1 .832.445l2 3A1 1 0 0 1 19 8H5a1 1 0 0 1-.832-1.555zM7.535 5 6.87 6h10.26l-.666-1h-8.93Z"
  })));
};
export default SvgShoppingBag;